export default "__VITE_ASSET__DzvS2V2$__"